import { call, put, takeLatest } from "redux-saga/effects";
import { assignMoodToUserRequest, createArtworkRequest, createGalleryRequest, deleteGalleryRequest, getArtworksRequest, getDefaultSpaceRequest, getGalleriesRequest, getSpacesRequest, getUsersRequest, unassignMoodFromUserRequest, updateArtworkRequest, updateGalleryRequest } from "./admin.api";


import * as AdminActions from './admin.actions';

function* getUsers() {
    const { data } = yield call(getUsersRequest)
    if (data.status) {
        yield put(AdminActions.GetUsersSuccess(data.users))
    } else {
        yield put(AdminActions.GetUsersFailed(data.msg))
    }
}

function* getSpaces() {
    const { data } = yield call(getSpacesRequest)
    if (data.status) {
        yield put(AdminActions.GetSpacesSuccess(data.spaces))
    } else {
        yield put(AdminActions.GetSpacesFailed(data.msg))
    }
}

function* createGallery(gallery: any) {
    const { navigate, gallery: g } = gallery.payload;
    const { data } = yield call(createGalleryRequest, g);
    if (data.status) {
        yield put(AdminActions.CreateGallerySuccess(data.gallery));
        navigate('/admin/galleries');
    } else {
        yield put(AdminActions.CreateGalleryFailed(data.error?.message || data.msg));
    }
}

function* updateGallery(gallery: any) {
    const { navigate, gallery: g } = gallery.payload;
    const { data } = yield call(updateGalleryRequest, g);
    if (data.status) {
        yield put(AdminActions.UpdateGallerySuccess(data.gallery));
        navigate('/admin/galleries');
    } else {
        yield put(AdminActions.UpdateGalleryFailed(data.msg));
    }
}

function* getArtworks() {
    const { data } = yield call(getArtworksRequest);
    if (data.status) {
        yield put(AdminActions.GetArtworksSuccess(data.artworks));
    } else {
        yield put(AdminActions.GetArtworksFailed(data.msg));
    }
}

function* createArtwork(artwork: any) {
    const { navigate, artwork: a} = artwork.payload;
    const { data } = yield call(createArtworkRequest, a);
    if (data.status) {
        yield put(AdminActions.CreateArtworkSuccess(data.artwork));
        navigate('/admin/artworks')
    } else {
        yield put(AdminActions.CreateArtworkFailed(data.msg));
    }
}

function* updateArtwork(artwork: any) {
    const { navigate, artwork: a} = artwork.payload;
    const { data } = yield call(updateArtworkRequest, a);
    if (data.status) {
        yield put(AdminActions.UpdateArtworkSuccess(data.artwork));
        navigate('/admin/artworks')
    } else {
        yield put(AdminActions.UpdateArtworkFailed(data.msg));
    }
}

function* getGalleries() {
    const { data } = yield call(getGalleriesRequest);
    if (data.status) {
        yield put(AdminActions.GetGalleriesSuccess({
            galleries: data.galleries, 
            spaces: data.spaces,
            artworks: data.artworks
        }));
    } else {
        yield put(AdminActions.GetGalleriesFailed(data.msg));
    }
}

function* getDefaultSpace() {
    const { data } = yield call(getDefaultSpaceRequest);

    if (data.status) {
        yield put(AdminActions.GetDefaultSpaceSuccess(data))
    } else {
        console.log(data)
        yield put(AdminActions.GetDefaultSpaceFailed(data.msg))
    }
}

function* assignMoodToUser(action: any) {
    const { spaceId, moodIndex, users } = action.payload;
    const { data } = yield call(assignMoodToUserRequest, spaceId, moodIndex, users);
    if (data.status) {
        yield put(AdminActions.AssignMoodToUserSuccess(data.space))
    } else {
        yield put(AdminActions.AssignMoodToUserFailed(data.msg))
    }
}

function* unassignMoodFromUser(action: any) {
    const { spaceId, moodIndex, users } = action.payload;
    const { data } = yield call(unassignMoodFromUserRequest, spaceId, moodIndex, users);
    if (data.status) {
        yield put(AdminActions.UnassignMoodFromUserSuccess(data.space))
    } else {
        yield put(AdminActions.UnassignMoodFromUserFailed(data.msg))
    }
}

function* deleteGallery(action: any) {
    const id = action.payload;
    const { data } = yield call(deleteGalleryRequest, id);
    if (data.status) {
        yield put(AdminActions.DeleteGallerySuccess(id))
    } else {
        yield put(AdminActions.DeleteGalleryFailed(data.msg))
    }
}
export default function* watchAdminActions () {
    yield takeLatest(AdminActions.GET_USERS, getUsers);
    yield takeLatest(AdminActions.GET_SPACES, getSpaces);
    yield takeLatest(AdminActions.GET_DEFAULT_SPACE, getDefaultSpace);
    yield takeLatest(AdminActions.GET_GALLERIES, getGalleries);
    yield takeLatest(AdminActions.DELETE_GALLERY, deleteGallery);
    yield takeLatest(AdminActions.UPDATE_GALLERY, updateGallery);
    yield takeLatest(AdminActions.CREATE_GALLERY, createGallery);
    yield takeLatest(AdminActions.GET_ARTWORKS, getArtworks);
    yield takeLatest(AdminActions.CREATE_ARTWORK, createArtwork);
    yield takeLatest(AdminActions.UPDATE_ARTWORK, updateArtwork);
    yield takeLatest(AdminActions.ASSIGN_MOOD_TO_USER, assignMoodToUser);
    yield takeLatest(AdminActions.UNASSIGN_MOOD_FROM_USER, unassignMoodFromUser);
}
